// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1591e924","81":"f23334a4","133":"fa7baae0","186":"ec35527b","225":"07bcf5b6","315":"f298cc5a","344":"3571c8df","372":"a458bf81","377":"634229c9","434":"881b1074","738":"b038a226","815":"79bf4c8c","841":"7e464ed7","856":"015efd59"}[chunkId] + ".chunk.js";
};